// package: 
// file: grpc-models/BusinessOnboarding.proto

var grpc_models_BusinessOnboarding_pb = require("../grpc-models/BusinessOnboarding_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var BusinessOnboardingProtoService = (function () {
  function BusinessOnboardingProtoService() {}
  BusinessOnboardingProtoService.serviceName = "BusinessOnboardingProtoService";
  return BusinessOnboardingProtoService;
}());

BusinessOnboardingProtoService.GetBusinessOnboardingDetails = {
  methodName: "GetBusinessOnboardingDetails",
  service: BusinessOnboardingProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_BusinessOnboarding_pb.GetBusinessOnboardingDetailsRequest,
  responseType: grpc_models_BusinessOnboarding_pb.GetBusinessOnboardingDetailsResponse
};

BusinessOnboardingProtoService.GetBusinessSegment = {
  methodName: "GetBusinessSegment",
  service: BusinessOnboardingProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_BusinessOnboarding_pb.GetBusinessSegmentRequest,
  responseType: grpc_models_BusinessOnboarding_pb.GetBusinessSegmentResponse
};

BusinessOnboardingProtoService.AddBusinessOnboardingDetails = {
  methodName: "AddBusinessOnboardingDetails",
  service: BusinessOnboardingProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_BusinessOnboarding_pb.AddBusinessOnboardingDetailsRequest,
  responseType: grpc_models_BusinessOnboarding_pb.AddBusinessOnboardingDetailsResponse
};

BusinessOnboardingProtoService.UpdateBusinessOnboardingDetails = {
  methodName: "UpdateBusinessOnboardingDetails",
  service: BusinessOnboardingProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_BusinessOnboarding_pb.UpdateBusinessOnboardingDetailsRequest,
  responseType: grpc_models_BusinessOnboarding_pb.UpdateBusinessOnboardingDetailsResponse
};

BusinessOnboardingProtoService.UpdateBusinessOnboardingCompletionStatus = {
  methodName: "UpdateBusinessOnboardingCompletionStatus",
  service: BusinessOnboardingProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_BusinessOnboarding_pb.UpdateBusinessOnboardingCompletionStatusRequest,
  responseType: grpc_models_BusinessOnboarding_pb.UpdateBusinessOnboardingCompletionStatusResponse
};

BusinessOnboardingProtoService.ScrapeBusinessOnboardingDetails = {
  methodName: "ScrapeBusinessOnboardingDetails",
  service: BusinessOnboardingProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_BusinessOnboarding_pb.ScrapeBusinessOnboardingDetailsRequest,
  responseType: grpc_models_BusinessOnboarding_pb.ScrapeBusinessOnboardingDetailsResponse
};

BusinessOnboardingProtoService.ScrapeAndUpdateBusinessOnboardingDetails = {
  methodName: "ScrapeAndUpdateBusinessOnboardingDetails",
  service: BusinessOnboardingProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_BusinessOnboarding_pb.UpdateBusinessOnboardingDetailsRequest,
  responseType: grpc_models_BusinessOnboarding_pb.ScrapeBusinessOnboardingDetailsResponse
};

BusinessOnboardingProtoService.SkipScraping = {
  methodName: "SkipScraping",
  service: BusinessOnboardingProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_BusinessOnboarding_pb.SkipScrapingRequest,
  responseType: grpc_models_BusinessOnboarding_pb.ScrapeBusinessOnboardingDetailsResponse
};

BusinessOnboardingProtoService.AddBusinessOnboardingDetailsTemp = {
  methodName: "AddBusinessOnboardingDetailsTemp",
  service: BusinessOnboardingProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_BusinessOnboarding_pb.AddBusinessOnboardingDetailsTempRequest,
  responseType: grpc_models_BusinessOnboarding_pb.AddBusinessOnboardingDetailsTempResponse
};

BusinessOnboardingProtoService.ScrapeBusinessOnboardingDetailsTemp = {
  methodName: "ScrapeBusinessOnboardingDetailsTemp",
  service: BusinessOnboardingProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_BusinessOnboarding_pb.ScrapeBusinessOnboardingDetailsRequest,
  responseType: grpc_models_BusinessOnboarding_pb.ScrapeBusinessOnboardingDetailsResponse
};

exports.BusinessOnboardingProtoService = BusinessOnboardingProtoService;

function BusinessOnboardingProtoServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

BusinessOnboardingProtoServiceClient.prototype.getBusinessOnboardingDetails = function getBusinessOnboardingDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BusinessOnboardingProtoService.GetBusinessOnboardingDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BusinessOnboardingProtoServiceClient.prototype.getBusinessSegment = function getBusinessSegment(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BusinessOnboardingProtoService.GetBusinessSegment, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BusinessOnboardingProtoServiceClient.prototype.addBusinessOnboardingDetails = function addBusinessOnboardingDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BusinessOnboardingProtoService.AddBusinessOnboardingDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BusinessOnboardingProtoServiceClient.prototype.updateBusinessOnboardingDetails = function updateBusinessOnboardingDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BusinessOnboardingProtoService.UpdateBusinessOnboardingDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BusinessOnboardingProtoServiceClient.prototype.updateBusinessOnboardingCompletionStatus = function updateBusinessOnboardingCompletionStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BusinessOnboardingProtoService.UpdateBusinessOnboardingCompletionStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BusinessOnboardingProtoServiceClient.prototype.scrapeBusinessOnboardingDetails = function scrapeBusinessOnboardingDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BusinessOnboardingProtoService.ScrapeBusinessOnboardingDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BusinessOnboardingProtoServiceClient.prototype.scrapeAndUpdateBusinessOnboardingDetails = function scrapeAndUpdateBusinessOnboardingDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BusinessOnboardingProtoService.ScrapeAndUpdateBusinessOnboardingDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BusinessOnboardingProtoServiceClient.prototype.skipScraping = function skipScraping(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BusinessOnboardingProtoService.SkipScraping, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BusinessOnboardingProtoServiceClient.prototype.addBusinessOnboardingDetailsTemp = function addBusinessOnboardingDetailsTemp(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BusinessOnboardingProtoService.AddBusinessOnboardingDetailsTemp, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BusinessOnboardingProtoServiceClient.prototype.scrapeBusinessOnboardingDetailsTemp = function scrapeBusinessOnboardingDetailsTemp(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BusinessOnboardingProtoService.ScrapeBusinessOnboardingDetailsTemp, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.BusinessOnboardingProtoServiceClient = BusinessOnboardingProtoServiceClient;

